// @ts-nocheck
import { all, takeLatest, call, put } from 'redux-saga/effects';
import { removeUser, setUser } from 'utils/storage.service';
import login from 'api/login';
import {
  login as loginAction,
  logout as logoutAction,
  loginSuccess
} from './slice';

export function* loginSaga(action: any) {
  try {
    const user = yield call(login, action.payload);

    console.log(`user`, user);
    if (user) {
      yield put(loginSuccess(user));

      setUser(user);
    } else {
      // yield put(loginFailure('Invalid Credentials'));
    }
  } catch (error) {
    console.log(`error`, error.message);

    // yield put(loginFailure(error.message));
  }
}

export function* logoutSaga() {
  try {
    removeUser();
    yield put(logoutSuccess());
  } catch (err) {
    yield put(loginFailure(err));
  }
}

export default function* userRootSaga() {
  yield all([yield takeLatest(loginAction.type, loginSaga)]);
  // yield all([yield takeLatest(logoutAction.typ e, logoutSaga)]);
}
